export class ActionCannotBeClosed extends Error {
  constructor() {
    super('Action cannot be closed.');
  }
}
